module.exports = __webpack_public_path__ + "img/mqttDTUgaishu1.4c42ca1a.png";